import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DeeplinkService } from 'src/app/services/deeplink.service';
import { DomSanitizer } from '@angular/platform-browser';
import { EnvironmentsService } from 'src/app/services/enviroment.service';
@Component({
  selector: 'app-deeplink-open',
  templateUrl: './deeplink-open.component.html',
  styleUrls: ['./deeplink-open.component.scss'],
})
export class DeeplinkOpenComponent {
  linkContract: any;
  linkStore: any;
  link: any;
  data: any;
  typeScreen: any;
  dataAction: any;
  deepLink: any;
  constructor(
    readonly route: ActivatedRoute,
    readonly deeplinkService: DeeplinkService,
    readonly sanitizer: DomSanitizer,
    readonly env: EnvironmentsService,
    readonly router: Router
  ) {
    this.link = window.location.href;
    this.data = this.link.split('?enc=')[1];
    if (this.data === 'link_inactive') {
      window.location.href = 'https://hi.fpt.vn';
    }
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent)) {
      if (/Android/i.test(navigator.userAgent)) {
        this.linkStore =
          'https://play.google.com/store/apps/details?id=com.rad.hifpt';
      } else if (/iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        this.linkStore =
          'https://apps.apple.com/vn/app/hi-fpt/id1144417173?l=vi';
      }
    }
  }

  ngAfterViewInit(): void {
    let data = {
      data: {
        data_input: this.data,
      },
      type_request: 'decode_link',
    };

    this.deeplinkService.decodeLink(data).subscribe((res: any) => {
      if (res && res.statusCode === 0) {
        this.data = undefined;
        this.dataAction = res.data.dataAction;
        this.deepLink = res.data.deep_link;
        const dtAction = res.data?.data?.action;
        const actionUrl = res.data?.data?.action_url;
        this.linkContract = res.data?.data?.url;
        this.typeScreen = res.data.data.type_screen ? res.data.data.type_screen.toLowerCase() : 'normal';
        sessionStorage.setItem('token_code', res.data?.data?.token_code);
        if (!dtAction && this.typeScreen === 'swap_wifi6') {
          // Neu ko co action thi giu luong cu
          // TypeScreen la normal hoac swap_wifi6
          // Neu typeScreen = swap_wifi6 thi chuyen sang trang swap wifi6
          // Neu typeScreen = normal thi giu trang normal (chi xay ra khi deeplink ko mo dc app)
          this.router.navigate(['/swap-wifi-6'], {
            queryParams: { id: res.data?.data?.utm_source, utm_source: res.data?.data?.utm_source },
          });
        } else if (dtAction && actionUrl && actionUrl !== '') {
          if (dtAction.toLowerCase() === 'redirect') {
            window.location.href = actionUrl;
          } else {
            this.router.navigate(actionUrl);
            this.data = undefined;
            // TypeScreen la normal hoac swap_wifi6
            // Neu typeScreen = swap_wifi6 thi chuyen sang trang swap wifi6
            // Neu typeScreen = normal thi giu trang normal (chi xay ra khi deeplink ko mo dc app)
            console.log(this.typeScreen);
          }
        } else {
          this.typeScreen = 'econtract';
          console.log(this.typeScreen);
        }
        // else if (res.data?.data?.action.toLowerCase() === 'redirect') {
        //   if (res.data?.data?.action_url && res.data?.data?.action_url !== '') {
        //     window.location.href = res.data?.data?.action_url;
        //   }
        // } else {
        //   if (res.data?.data?.action_url && res.data?.data?.action_url !== '') {
        //     this.router.navigate(res.data?.data?.action_url);
        //     this.linkContract = res.data?.data?.url
        //       ? res.data?.data?.url
        //       : '';
        //
        //     sessionStorage.setItem('token_code', res.data?.data?.token_code);
        //     this.data = undefined;
        //     // TypeScreen la normal hoac swap_wifi6
        //     // Neu typeScreen = swap_wifi6 thi chuyen sang trang swap wifi6
        //     // Neu typeScreen = normal thi giu trang normal (chi xay ra khi deeplink ko mo dc app)
        //     this.typeScreen = res.data?.data?.type_screen
        //       ? res.data?.data?.type_screen.toLowerCase()
        //       : 'normal';
        //     console.log(this.typeScreen);
        //   } else {
        //     this.typeScreen = 'econtract';
        //
        //     this.linkContract = res.data?.data?.url
        //       ? res.data?.data?.url
        //       : '';
        //     console.log(this.typeScreen);
        //   }
        // }
      }
    });
  }
}
